


import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, EMPTY } from 'rxjs';
import { tap, map, switchMap, take, catchError, withLatestFrom, filter, concatMap, mergeMap } from 'rxjs/operators';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';
import { get, mergeWith } from 'lodash';

import { getValue } from '@app/shared/utils/feature-utils';
import * as fromStore from '@app/core/store';
import * as fromMaster from '../store/master-search-0.actions';
import { ActionHandler } from '@app/core/components/actions/action.handler';
import { MessagesService } from '@app/core/services/messages/message.service';
import { environment } from '@env/environment';
const BASE_PATH = environment.basePath;
@Injectable()
export class MasterSearch0Effects {
  constructor(
    private actions$: Actions,
    private actionHandler: ActionHandler,
    private store: Store<fromStore.State>,
    private message: MessagesService,
    private httpClient: HttpClient,
  ) { }

  count$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromMaster.countAction),
      switchMap(payload => {
        return of(0)
          .pipe(
            map(
              result =>
                fromMaster.countSuccessAction({
                  ...payload,
                  totalItems: result
                })
            ),
            catchError(error => {
              this.message.openErrorMessage(error);
              return of(fromMaster.countFailAction({ ...payload, error }));
            }
            )
          )
      })
    )
  );

  find$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromMaster.searchAction),
      switchMap(payload => {
        return of([])
          .pipe(
            map(
              result =>
                fromMaster.searchSuccessAction({
                  ...payload,
                  value: result
                })
            ),
            catchError(error => {
              this.message.openErrorMessage(error);
              return of(fromMaster.searchFailAction({ ...payload, error }));
            }
            )
          )
      })
    )
  );




}


